import { getJsonFromStorage } from './storage';

export const getInitialValueFromStorage = (key, defaultValue) => {
  const data = getJsonFromStorage(key);

  if (data && data.data) {
    return { data: data.data, loading: false, fail: false };
  }

  return { data: defaultValue, loading: false, fail: false };
};

export const getImagesStaticUrl = (url) => `${process.env.REACT_APP_STATIC_MEDIA}/images/${url}`;
